import { Dispatch } from 'redux';
import Service from 'src/setup/network';
import { Billings, Pagination } from 'src/types/model';
import { BillingActionType, FETCH_BILLING_FAILURE, FETCH_BILLING_REQUEST, FETCH_BILLING_SUCCESS } from '../types/billingType';

export interface FetchBillingParams {
  limit?: number;
  page?: number;
}

export const fetchBillingRequest = (): BillingActionType => ({
  type: FETCH_BILLING_REQUEST,
});

export const fetchBillingSuccess = (
  data: Billings[],
  pagination: Pagination
): BillingActionType => ({
  type: FETCH_BILLING_SUCCESS,
  payload: { data, pagination },
});

export const fetchBillingFailure = (error: string): BillingActionType => ({
  type: FETCH_BILLING_FAILURE,
  payload: error,
});

export const fetchBilling = (filters?: FetchBillingParams) => {
  return async (dispatch: Dispatch<BillingActionType>) => {
    dispatch(fetchBillingRequest());

    try {
      const queryParams = filters
        ? '?' +
          Object.entries(filters)
            .filter(([_, value]) => value !== undefined && value !== '')
            .map(
              ([key, value]) =>
                `${encodeURIComponent(key)}=${encodeURIComponent(
                  value as string
                )}`
            )
            .join('&')
        : '';
  // localhost:8001/api/billing-cycles/my-cycles?page=1&limit=10
      const response = await Service.get(`/billing-cycles/my-cycles${queryParams}`);
      const data: Billings[] = response?.data?.data ?? [];
      const pagination: Pagination = response?.data?.pagination ?? {};
      dispatch(fetchBillingSuccess(data, pagination));
    } catch (error: any) {
      const errorMsg =
        error?.response?.data?.message ||
        error?.message ||
        'Failed to fetch expenses';
      dispatch(fetchBillingFailure(errorMsg));
      throw new Error(errorMsg);
    }
  };
};